module.exports = __webpack_public_path__ + "img/nature-call.a8b47005.png";